module.exports = __webpack_public_path__ + "static/part-14_ovr-0f07d5a5b6819f31f01a2bbd9da62898.svg";